export default __webpack_public_path__ + "static/media/forever.ed5a4fdd.jpeg";